<template>
  <a href="https://tailcake.dev/" class="flex">
    <div class="mx-4">
      <img src="tailcake-logo.png" class="w-8 h-8" alt="tailcake" />
    </div>
    <div class="m-auto text-xl font-semibold">TailCake</div>
  </a>
</template>
